import React from "react";
import { useLanguage } from "@/contexts/LanguageContext";
import { CheckCircle2, Loader2 } from "lucide-react";

const STAGES = [
  { key: "received", label_ar: "تم الاستلام", label_en: "Received" },
  { key: "outline", label_ar: "بناء المخطط", label_en: "Outline" },
  { key: "writing", label_ar: "الكتابة", label_en: "Writing" },
  { key: "references", label_ar: "التحقق من المراجع", label_en: "Reference check" },
  { key: "quality_gate", label_ar: "بوابة الجودة", label_en: "Quality gate" },
  { key: "file_prep", label_ar: "تجهيز الملف", label_en: "File prep" },
  { key: "delivered", label_ar: "تم التسليم", label_en: "Delivered" },
];

export const ProgressTracker = ({ order }) => {
  const { lang } = useLanguage();
  const current = order?.progress_stage || "received";
  const percent = order?.progress_percent ?? 0;
  const currentIdx = Math.max(0, STAGES.findIndex((s) => s.key === current));
  return (
    <div className="space-y-3" data-testid={`progress-tracker-${order?.id}`}>
      <div className="h-1.5 w-full bg-slate-100 rounded-full overflow-hidden">
        <div
          className="h-full bg-slate-900 transition-all duration-500"
          style={{ width: `${percent}%` }}
          data-testid={`progress-bar-${order?.id}`}
        />
      </div>
      <ol className="flex flex-wrap items-center gap-x-3 gap-y-2 text-[11px] text-slate-600">
        {STAGES.map((s, i) => {
          const done = i < currentIdx || current === "delivered";
          const active = i === currentIdx && current !== "delivered";
          return (
            <li
              key={s.key}
              className={`inline-flex items-center gap-1 ${
                done ? "text-emerald-700" : active ? "text-slate-900 font-medium" : "text-slate-400"
              }`}
            >
              {done ? <CheckCircle2 className="w-3.5 h-3.5" /> : active ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <span className="w-3.5 h-3.5 rounded-full border border-current opacity-50" />}
              <span>{lang === "ar" ? s.label_ar : s.label_en}</span>
            </li>
          );
        })}
      </ol>
      <p className="text-[11px] text-slate-500">
        {lang === "ar"
          ? "عادةً 3–5 دقائق. يمكنك إغلاق الصفحة بأمان — سنحفظ النتيجة في طلباتي."
          : "Usually 3–5 minutes. You can safely close this page — we'll save the result to your archive."}
      </p>
    </div>
  );
};

export default ProgressTracker;
